import {createSlice, ActionReducerMapBuilder} from '@reduxjs/toolkit'
import {POLICY_TYPE, RESOURCE_TYPE} from 'interfaces'
import {
  addEntityTypeFilter,
  setViolationTypeFilter,
  removeEntityTypeFilter,
  resetTopTenBlocksFilterState,
} from './analyticsPolicyActions'

export interface TopBlocksFilterState {
  violationTypeFilters: POLICY_TYPE[]
  entityTypeFilters: RESOURCE_TYPE[]
}

const initialState: TopBlocksFilterState = {
  violationTypeFilters: [
    POLICY_TYPE.Policy,
    POLICY_TYPE.Malware,
    POLICY_TYPE.CAC,
  ],
  entityTypeFilters: [],
}

const analyticPolicyTopBlocksSlice = createSlice({
  name: 'analyticPolicyTopBlocks',
  initialState,
  reducers: {},
  extraReducers: (builder: ActionReducerMapBuilder<TopBlocksFilterState>) =>
    builder
      .addCase(setViolationTypeFilter, (state, action) => ({
        ...state,
        violationTypeFilters: action.payload || [],
      }))
      .addCase(addEntityTypeFilter, (state, action) => ({
        ...state,
        entityTypeFilters: [...state.entityTypeFilters, action.payload],
      }))
      .addCase(removeEntityTypeFilter, (state, action) => ({
        ...state,
        entityTypeFilters: state.entityTypeFilters.filter(
          (filter: RESOURCE_TYPE) => filter !== action.payload,
        ),
      }))
      .addCase(resetTopTenBlocksFilterState, state => ({
        ...state,
        violationTypeFilters: [...initialState.violationTypeFilters],
        entityTypeFilters: [...initialState.entityTypeFilters],
      }))
      .addDefaultCase(state => state),
})

export const {
  reducer: analyticPolicyTopBlocksReducer,
  name: analyticPolicyTopBlocksReducerName,
} = analyticPolicyTopBlocksSlice

export type AnalyticPolicyTopBlocksReducerState = ReturnType<
  typeof analyticPolicyTopBlocksReducer
>

// export analytics policy action types
export type TAnalyticsPolicyActions =
  // top 10 blocks actions
  | ReturnType<typeof setViolationTypeFilter>
  | ReturnType<typeof addEntityTypeFilter>
  | ReturnType<typeof removeEntityTypeFilter>
  | ReturnType<typeof resetTopTenBlocksFilterState>

export const analyticsPolicyActions = {
  setViolationTypeFilter,
  addEntityTypeFilter,
  removeEntityTypeFilter,
  resetTopTenBlocksFilterState,
}
